import _ from "lodash";

export const priceNumberFormat = (value) => {
  if (!value) {
    return "0.00";
  }
  return value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export const priceFormat = (value, fixed = 2) => {
  if (!value) {
    return "0.00".toFixed(fixed);
  }
  return value.toFixed(fixed).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export const qtyNumberFormat = (value) => {
  if (!value) {
    return "0";
  }
  return value.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export const sumTotal = (field, value) => {
  return _.sumBy(field, _.partial(_.sumBy, value));
};
